import { render } from "./footerComponet.vue?vue&type=template&id=e71342a6&scoped=true"
import script from "./footerComponet.vue?vue&type=script&lang=js"
export * from "./footerComponet.vue?vue&type=script&lang=js"

import "./footerComponet.vue?vue&type=style&index=0&id=e71342a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71342a6"]])

export default __exports__